import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchPlatformTenant } from "../../lib/opsGraphql";

export default function TenantDetail() {
  const { tenantId } = useParams();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    fetchPlatformTenant(tenantId)
      .then(setTenant)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <p className="ops-loading">Cargando tenant…</p>;
  if (error) return <p className="ops-error">{error}</p>;
  if (!tenant) return <p>Tenant no encontrado.</p>;

  const usage = tenant.usage_summary;

  return (
    <>
      <div className="ops-card">
        <h2>{tenant.name}</h2>
        <p>
          <code>{tenant.tenant_id}</code> · {tenant.status}
          {tenant.is_demo && <span className="ops-badge warning"> demo</span>}
        </p>
        <nav className="ops-nav" style={{ marginTop: 16 }}>
          <Link to={`/tenants/${tenantId}/plan`}>Plan</Link>
          <Link to={`/planes?tenant=${tenantId}`}>Gestionar plan</Link>
          <Link to={`/tenants/${tenantId}/consumo`}>Consumo</Link>
          <Link to={`/tenants/${tenantId}/contrato`}>Contrato</Link>
          <Link to={`/tenants/${tenantId}/billing`}>Facturación</Link>
        </nav>
      </div>

      {usage && (
        <div className="ops-card">
          <h3>Consumo mes actual ({usage.period})</h3>
          <div className="ops-stats-grid">
            <div>
              <span className="ops-stat-label">Documentos</span>
              <strong>
                {usage.documents_processed}
                {usage.documents_limit != null ? ` / ${usage.documents_limit}` : ""}
              </strong>
              {usage.plan_exceeded && <span className="ops-badge danger">Excedido</span>}
            </div>
            <div>
              <span className="ops-stat-label">Tokens fallback</span>
              <strong>{usage.fallback_tokens_used.toLocaleString("es-AR")}</strong>
            </div>
            <div>
              <span className="ops-stat-label">Copilot (informativo)</span>
              <strong>
                {(usage.copilot_input_tokens || 0) + (usage.copilot_output_tokens || 0)} tokens
              </strong>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
